import { joinPartnerDiscounts } from 'helpers/partner.helpers';
import React, { useMemo } from 'react';
import { useFormContext, useWatch } from 'react-hook-form';
import { IPartnerCreate } from 'types/Partner';

import TouchRipple from '@material-ui/core/ButtonBase/TouchRipple';
import {
  FormControl,
  FormHelperText,
  InputLabel,
  MenuItem,
  Select as MaterialSelect,
  styled,
} from '@mui/material';

const Select = styled(MaterialSelect)(({ theme }) => ({
  '& .Mui-disabled': {
    color: theme.palette.text.primary,
    textFillColor: theme.palette.text.primary,
  },
}));

export const DiscountsInput: React.FC<{ onClick: () => void }> = ({
  onClick,
}) => {
  const { control, formState } = useFormContext<IPartnerCreate>();

  const discounts = useWatch({ control, name: 'discounts' });
  const error = formState.errors.discounts?.message;

  const valuePreview = useMemo(
    () => joinPartnerDiscounts(discounts, true),
    [discounts]
  );

  return (
    <FormControl fullWidth error={Boolean(error)}>
      <InputLabel id="discounts-label">DESCONTOS</InputLabel>

      <Select
        labelId="discounts-label"
        label="DESCONTOS"
        value={valuePreview}
        inputProps={{ readOnly: true }}
      >
        <MenuItem value={valuePreview}>{valuePreview}</MenuItem>
      </Select>

      <TouchRipple
        onClick={onClick}
        style={{
          position: 'absolute',
          pointerEvents: 'all',
          cursor: 'pointer',
        }}
      />

      <FormHelperText>{error}</FormHelperText>
    </FormControl>
  );
};

